/**
 * domain-tlds.ts — prisliste per domeneendelse (én kilde for hele domeneområdet)
 *
 * ⚠ PLASSHOLDERE: endelser og priser er foreløpige. Dette er ~25 av de mange tusen
 * endelsene som finnes, og listen er laget slik at den kan byttes mot et prisfeed fra
 * registraren (backend) uten å endre komponentene. Priser i hele kroner, per år, eks. mva.
 * Kun enkelt-ledd (ikke «co.uk»). Brukes av søk (chips/resultater), kort, tabell og
 * TLD-listen.
 */

import type { DomainTld } from '@/types/domain';

export const DOMAIN_TLDS: DomainTld[] = [
  { tld: 'no', type: 'country', category: 'popular', popular: true, register: 99, renew: 99, transfer: 99 },
  { tld: 'com', type: 'generic', category: 'popular', popular: true, register: 220, renew: 220, transfer: 220 },
  { tld: 'net', type: 'generic', category: 'popular', popular: true, register: 240, renew: 240, transfer: 240 },
  { tld: 'org', type: 'generic', category: 'popular', popular: true, register: 220, renew: 220, transfer: 220 },
  { tld: 'eu', type: 'country', register: 150, renew: 150, transfer: 150 },
  { tld: 'se', type: 'country', register: 180, renew: 180, transfer: 180 },
  { tld: 'dk', type: 'country', register: 160, renew: 160, transfer: 160 },
  { tld: 'fi', type: 'country', register: 170, renew: 170, transfer: 170 },
  { tld: 'de', type: 'country', register: 120, renew: 120, transfer: 120 },
  { tld: 'info', type: 'generic', category: 'business', register: 190, renew: 260, transfer: 190 },
  { tld: 'biz', type: 'generic', category: 'business', register: 210, renew: 260, transfer: 210 },
  { tld: 'online', type: 'new', category: 'business', register: 60, renew: 360, transfer: 360 },
  { tld: 'shop', type: 'new', category: 'business', register: 70, renew: 420, transfer: 420 },
  { tld: 'store', type: 'new', category: 'business', register: 80, renew: 400, transfer: 400 },
  { tld: 'site', type: 'new', register: 40, renew: 300, transfer: 300 },
  { tld: 'xyz', type: 'new', register: 30, renew: 190, transfer: 190 },
  { tld: 'io', type: 'country', category: 'tech', register: 440, renew: 440, transfer: 440 },
  { tld: 'ai', type: 'country', category: 'tech', register: 620, renew: 620, transfer: 620 },
  { tld: 'dev', type: 'new', category: 'tech', register: 160, renew: 160, transfer: 160 },
  { tld: 'app', type: 'new', category: 'tech', register: 180, renew: 180, transfer: 180 },
  { tld: 'tech', type: 'new', category: 'tech', register: 90, renew: 520, transfer: 520 },
  { tld: 'design', type: 'new', category: 'creative', register: 300, renew: 420, transfer: 300 },
  { tld: 'studio', type: 'new', category: 'creative', register: 200, renew: 280, transfer: 200 },
  { tld: 'art', type: 'new', category: 'creative', register: 50, renew: 220, transfer: 220 },
  { tld: 'photo', type: 'new', category: 'creative', register: 160, renew: 260, transfer: 160 },
  { tld: 'blog', type: 'new', category: 'creative', register: 220, renew: 330, transfer: 220 },
];

/** Endelser uten punktum, for validering av søk */
export const DOMAIN_TLD_CODES = DOMAIN_TLDS.map((t) => t.tld);

/** Populære endelser (chips, kort) */
export const DOMAIN_POPULAR = DOMAIN_TLDS.filter((t) => t.popular);
